import confettiCannon from '@wt/utilities/confettiCannon';
import { useRef } from 'react';

const CrateButton = (props: { i: number; handleSelect: () => void }) => {
  const ref = useRef<HTMLDivElement>(null);
  const style = { width: '10rem', height: '7rem' };
  const clazz =
    'select-none text-7xl flex items-center justify-center cursor-pointer transition-transform hover:scale-125 ';

  return (
    <div
      ref={ref}
      onClick={() => {
        props.handleSelect();
        // Throw out confetti from this box!
        if (ref.current) {
          const rect = ref.current.getBoundingClientRect();
          confettiCannon({
            x: (rect.x + rect.width / 2) / window.innerWidth,
            y: (rect.y + 0.6 * rect.height) / window.innerHeight,
          });
        }
      }}
      className={clazz}
      style={style}
    >
      🎁
    </div>
  );
};

export default CrateButton;
